import { render } from "./OrderItems.vue?vue&type=template&id=1aa3372f&scoped=true"
import script from "./OrderItems.vue?vue&type=script&lang=js"
export * from "./OrderItems.vue?vue&type=script&lang=js"

import "./OrderItems.vue?vue&type=style&index=0&id=1aa3372f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa3372f"]])

export default __exports__